import React from 'react'
import { Input } from "@/components/ui/input";

interface IRoleDetailsSection {
  role: string,
  setRole: (role: string) => void
}

function RoleSection({ role, setRole }: IRoleDetailsSection) {
  return (
    <section className="space-y-6 p-3 bg-white 
      border-2 border-gray-200 rounded-xl">
      <h2 className="text-xl text-indigo-600 font-medium">
        <div>Role Title</div> 
        <span className="text-sm">(the role you are preparing this resume for)</span>
      </h2>
      <Input placeholder="Role title..." id="role" value={role} 
        onChange={(e) => setRole(e.target.value)} />
    </section>
  )
}

export default RoleSection